import type { FaireProductEntity } from "../../entity_types/product";

export const p_6twf4jbu65: FaireProductEntity = {
  token: "p_6twf4jbu65",
  type: "product",
  name: "The Billie Dress in Chunky Windowpane - Cream",
  brandToken: "b_wchx4fhhck",
  brandName: "Ersa Fibers",
  imageUrl:
    "https://cdn.faire.com/fastly/ad0211883fbeee13be8df5ceced151753b75265dcdf913cb0e8c714c8a16be4d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05a44e34699abb48d89cb412df0602174f0833c185a5f117d3c56ddb5ddbca56.jpeg",
    "https://cdn.faire.com/fastly/8bba5d0d78145b00e3819cd966e504833133861dff73746563c2816fbf8be796.jpeg",
    "https://cdn.faire.com/fastly/4cb7ec8750b7a7c9b72ffc652b0b9981e6c439e5472356574c4ed6937013f1d1.jpeg",
  ],
  priceDollars: 107.5,
  description:
    "The Billie Dress in Chunky Windowpane is a prairie-style dress, featuring a flattering square neckline, short sleeves, loose fit, and the perfect knee length.\n\nIts airy fit mixed with the bold bright print makes it a comfortable everyday statement piece that can be dressed up or dressed down for any occasion.\n\n• Hand sewn\n\n• 100% Linen Cotton\n\n• Printed with high-quality eco-friendly ink.\n\n𝐏𝐥𝐞𝐚𝐬𝐞 𝐫𝐞𝐚𝐝 𝐛𝐞𝐟𝐨𝐫𝐞 𝐨𝐫𝐝𝐞𝐫𝐢𝐧𝐠:\n\nThese fabrics are custom printed in small batches. Every batch of fabric is slightly different. Due to the unique printing process, please expect small character marks similar to block-printed fabric or any other hand-printed fabric :)",
  tags: [],
  msrpDollars: 215,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:59.835Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
